import React, { Fragment, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setVideoTourClockTicks } from "./actions";

const VideoTourClockService = () => {
	const dispatch = useDispatch();
	const videoTourInstances = useSelector(state => state.videoTourClock.instances);
	const timerRef = useRef(null);

	useEffect(() => {
		if (videoTourInstances.length > 0) {
			if (!timerRef.current) {
				let ticks = 0;
				timerRef.current = setInterval(() => {
					ticks++;
					dispatch(setVideoTourClockTicks(ticks));
				}, 1000);
			}
		} else {
			if (timerRef.current) {
				dispatch(setVideoTourClockTicks(null));
				clearInterval(timerRef.current);
				timerRef.current = null;
			}
		}
	}, [videoTourInstances]);

	return <Fragment />;
};

export default VideoTourClockService;
